import React from 'react';
import { useTranslation } from '@app/core/i18n';

import BarsAlt from '@ast/magma/components/icon/icons/BarsAlt';

import { Button } from '@ast/magma/components/button';

import styles from './EventLogFilter.pcss';

export enum Directions {
  acs = 'asc',
  desc = 'desc',
}

type Props = {
  direction: Directions;
  onChangeDirection: () => void;
};

export const EventLogFilter: React.FC<Props> = ({
  direction,
  onChangeDirection,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Button
        data-stable-name="ChangeSortDirection"
        className={styles.iconWrapper}
        onClick={onChangeDirection}
        type="button"
        look="inlinetext"
        aria-label={(direction === Directions.desc)
          ? t('event-log-filter.sort.desc|Descending order aria-label', 'Sort in descending order')
          : t('event-log-filter.sort.asc|Ascending order aria-label', 'Sort in ascending order')}
      >
        {t('event-log-filter.text|Sort text', 'Sort by ')}
        {t('event-log-filter.sortable-field|Sortable field', 'date')}
        <BarsAlt
          className={
            direction === Directions.desc ? styles.sortDesc : styles.sortAsc
          }
        />
      </Button>
    </div>
  );
};
